import { authorizations } from "@/mocks/documentos";
import DocumentStatusBadge from "./DocumentStatusBadge";

export default function AuthorizationsTable() {
  const typeIconMap: Record<string, string> = {
    "Autorização de poda": "ri-scissors-line",
    "Autorização de supressão": "ri-close-line",
    "Autorização de transplante": "ri-plant-line",
    "Laudo fitossanitário": "ri-microscope-line",
    "Parecer de risco": "ri-error-warning-line",
    "Parecer jurídico/ambiental": "ri-scales-line",
    "Termo de compensação": "ri-recycle-line",
  };

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Autorizações ambientais e laudos técnicos</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 text-left">
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Tipo</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Número</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Título</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Vínculo</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Órgão emissor</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Responsável</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Emissão</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Validade</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Status</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {authorizations.map((auth) => (
              <tr key={auth.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-1.5">
                    <div className="w-6 h-6 rounded-md bg-warning-50 flex items-center justify-center">
                      <i className={`${typeIconMap[auth.type] || "ri-file-line"} text-warning-600 text-xs`} />
                    </div>
                    <span className="text-xs text-foreground-700 font-medium">{auth.type}</span>
                  </div>
                </td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 font-mono whitespace-nowrap">{auth.number}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-700 max-w-[180px] truncate">{auth.title}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-600">{auth.ctaCode || auth.areaName || "—"}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 max-w-[140px] truncate">{auth.issuingBody}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-600 max-w-[140px] truncate">{auth.responsibleTech}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 whitespace-nowrap">{auth.issueDate}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 whitespace-nowrap">{auth.expiryDate || "—"}</td>
                <td className="py-2.5 px-3"><DocumentStatusBadge status={auth.status} /></td>
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-1">
                    <button className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center text-foreground-500 hover:text-accent-600 transition-colors" title="Visualizar">
                      <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    </button>
                    <button className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors" title="Baixar">
                      <i className="ri-download-line w-4 h-4 flex items-center justify-center" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}